import { createStore } from 'vuex'

const state = {
  currentRoute: 'login',
  userEmail: '',
  appProps: {},
  routeProps: {}
}

const mutations = {
  setRoute(state, val) {
    state.currentRoute = val
  },
  setAppProps(state, val) {
    state.appProps = val
  },
  setRouteProps(state, val) {
    state.routeProps = val
  },
  setUserEmail(state, val) {
    state.userEmail = val
  },
}
const store = createStore({
  state: state,
  mutations: mutations,
})

export default store
